import React, { useContext, useEffect, useRef, useState } from 'react';
import { ReactComponent as PhotoIcon } from '@/assets/photo.svg';
import { attachMessages } from '../i18n';
import { useIntl } from 'react-intl';
import { Item } from './Item';
import { IAttachItemProps } from '../../types';
import { configurationContext } from 'src/contexts/configuration';

/**
 * `m3_ep` value set exclusively by the configurator's live preview
 * (`AppInstance.tsx`) when mounting the widget. Used here only to bypass
 * the camera-capture feature detection below, so operators can see the
 * effect of the "photo" `attach_ui` toggle from a desktop browser without
 * needing an actual mobile device.
 */
const CONFIGURATOR_PREVIEW_M3_EP = 'preview';

export const AttachPhoto = ({ onSelect }: IAttachItemProps) => {
	const intl = useIntl();
	const { m3_ep } = useContext(configurationContext);
	const isConfiguratorPreview = m3_ep === CONFIGURATOR_PREVIEW_M3_EP;
	const photoText = intl.formatMessage(attachMessages.photo);
	const photoInputRef = useRef<HTMLInputElement>(null);
	const [isAvailable, setIsAvailable] = useState(isConfiguratorPreview);

	useEffect(() => {
		// Skip real feature detection in the configurator preview: forcing
		// availability there lets operators verify the "photo" toggle
		// regardless of the desktop browser's camera-capture support.
		if (isConfiguratorPreview) return;
		const el = document.createElement('input');
		setIsAvailable(el.capture != undefined);
	}, [isConfiguratorPreview]);

	if (!isAvailable) return null;

	return (
		<Item
			icon={<PhotoIcon className="icon photo" />}
			text={photoText}
			className="photo"
			onClick={() => photoInputRef.current?.click()}
		>
			<input
				type="file"
				accept="image/*"
				hidden
				ref={photoInputRef}
				onChange={onSelect}
				capture
			/>
		</Item>
	);
};
